import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { approvedRejectedBrandFailure, approvedRejectedBrandSuccess } from '../../actions/brandActions/approvedRejectedBrandActions';
import store from '../../configStore';

function* approvedRejectedBrand({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.markApprovedRejectedBrand,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("APPROVED_REJECTED_BRAND_SUCCESS status :", response.data.status);
        console.log("APPROVED_REJECTED_BRAND_SUCCESS data :", response.data.response);
        console.log("APPROVED_REJECTED_BRAND_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            approvedRejectedBrandSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("APPROVED_REJECTED_BRAND_FAILURE status :", error?.response?.status);
        console.log("APPROVED_REJECTED_BRAND_FAILURE data:", error?.response?.data);
        console.log("APPROVED_REJECTED_BRAND_FAILURE error :", error);
        console.log('====================================');
        yield put(approvedRejectedBrandFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* approvedRejectedBrandSaga() {
    yield takeLatest(actionTypes.APPROVED_REJECTED_BRAND_REQUEST, approvedRejectedBrand);
}

export default approvedRejectedBrandSaga;
